import { IncentiveCategory } from '@varo/graphql-schema-types';
import IncentiveOptedInScreen from 'features/incentive/screens/IncentiveOptedInScreen/IncentiveOptedInScreen';

export default function IncentiveOptedInPage() {
  return (
    <IncentiveOptedInScreen incentiveType={IncentiveCategory.Sweepstakes} />
  );
}
